import React from "react";
import clsx from "clsx";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import IColumn from "interfaces/Column";
import ListRow from "./ListRow";

import useStyles from "./styles";

export type TListItem = racehorse360.IHorseRisk | racehorse360.IHorseOnList;
const setDefaultRemoveItemButtonShowingRules = () => false;

interface IProps {
  tabName: string;
  items: TListItem[];
  columns: IColumn[];
  isAlertItemPredicate?: (item: TListItem) => boolean;
  commentsSource?: string[];
  getRemoveItemButtonShowingRules?: (
    item: TListItem,
    columnIndex: number
  ) => boolean;
}

const ListTable = (props: IProps) => {
  const {
    tabName,
    items,
    columns,
    isAlertItemPredicate = () => false,
    commentsSource = [],
    getRemoveItemButtonShowingRules = setDefaultRemoveItemButtonShowingRules
  } = props;

  const classes = useStyles();

  if (!items?.length) {
    return <div className={classes.emptyDataHolder}>No {tabName}</div>;
  }

  const rowsContent = items.map(item => (
    <ListRow
      key={item.id}
      rowItem={item}
      columns={columns}
      isAlertItemPredicate={isAlertItemPredicate}
      commentsSource={commentsSource}
      getRemoveItemButtonShowingRules={getRemoveItemButtonShowingRules}
    />
  ));

  return (
    <TableContainer className={classes.tableContainer}>
      <Table>
        <TableBody className={classes.tableBody}>
          <TableRow className={classes.tableHead}>
            {columns.map(column => (
              <TableCell
                key={column.id}
                className={clsx(classes.tableHeadCell)}
              >
                {column.title}
              </TableCell>
            ))}
          </TableRow>

          {rowsContent}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default React.memo(ListTable);
